import styled from 'styled-components';
import { FormField, FormFieldHeader, HorizontalInput } from 'ui/formField';
import { StyledTextAreaWrapper } from 'ui/inputs/textArea/TextArea.styles';
import { body2, colors, fontWeights, spacing } from 'ui/theme';

export const StyledVariantFormField = styled(FormField)`
  width: 100%;
  display: flex;
  align-items: baseline;
  & + & {
    margin: 0;
  }
  ${FormFieldHeader} {
    min-width: ${spacing.x10};
    max-width: ${spacing.x10};
    margin: 0;
    label {
      font-weight: ${fontWeights.semiBold};
    }
  }
`;

export const SelectFormFieldWrapper = styled(StyledVariantFormField)`
  ${HorizontalInput} {
    overflow: auto;
  }
`;

export const HiddenVariantFormField = styled(StyledVariantFormField)`
  display: none;
`;

export const VariantFormFieldValue = styled.div`
  ${body2}
  color: ${colors.textPrimary};
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-word;
  white-space: break-spaces;
`;

export const VariantPlaceholderText = styled.div`
  ${body2}
  color: ${colors.textDisabled};
  font-style: italic;
`;

export const StyledVariantTextAreaFormField = styled(StyledVariantFormField)`
  ${StyledTextAreaWrapper} {
    flex-direction: row;
  }
`;
